import React from 'react';

export default function Users() {
  return (
    <div className="page">
      <h1>Users Management</h1>
      <div className="table-container">
        <table>
          <thead>
            <tr><th>ID</th><th>Name</th><th>Email</th><th>Status</th></tr>
          </thead>
          <tbody>
            <tr><td>1</td><td>Ahmed</td><td>ahmed@example.com</td><td>Active</td></tr>
            <tr><td>2</td><td>Fatima</td><td>fatima@example.com</td><td>Active</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
